import "../css"

import dragula from "dragula"
import "dragula/dist/dragula.css"

import { csrfToken } from "#/application/js/utils"

const currentOrder = () => Array.from(document.querySelectorAll("li[data-id]")).map(el => el.dataset.id)

$(function() {
  const container = document.getElementById("reorder")
  if (container) {
    let origOrder
    const drake = dragula([container])

    drake.on("drag", () => origOrder = currentOrder())

    drake.on("dragend", el => {
      const { id } = el.dataset
      const ix = currentOrder().indexOf(id)
      if (ix == origOrder.indexOf(id)) return

      const data = new FormData()
      data.append("id", id)
      data.append("index", ix)

      fetch(container.dataset.url, {
        method: "PATCH",
        headers: csrfToken(),
        body: data
      })
    })
  }
})
